import { CheckboxItem } from '@pc/common';
import { ITraveler } from '@pc/traveller-details-card';
import { IMedicalAnswer } from '../../pages/traveller-details/models/medical-data.model';

export interface Traveler extends ITraveler {
  id: string;
  title: TravelerTitle;
  type: TravelerType;
  participantNum: number;
  personalNumId: string | null;
  customerID: string | null;
  firstName: string;
  surName: string;
  email: string | null;
  phoneNumber: string | null;
  mobileCountryId: number;
  dateOfBirth: string | undefined;
  age: number;
  state: CheckboxItem | undefined;
  isEditMode: boolean;
  medicalQuestions: IMedicalAnswer[];
  productCover: ProductCover[];
}

export interface ProductCover {
  productID: number;
  coversIds: number[];
}

export interface TravelersAges {
  age: number | null;
  dateOfBirth: string;
  type: TravelerType;
  participentNum: number;
  customerID: string | null;
}

export enum TravelerType {
  ADULT = 1,
  CHILD = 2,
  DEPENDANT = 3
}

export enum TravelerTitle {
  Mr = 'Mr',
  Ms = 'Ms',
  Mrs = 'Mrs'
}

export function getNewTraveler(type: TravelerType): Traveler {
  return {
    type: type,
    age: -1,
    id: '',
    title: TravelerTitle.Mr,
    participantNum: 0,
    personalNumId: null,
    customerID: null,
    firstName: '',
    surName: '',
    email: null,
    phoneNumber: null,
    mobileCountryId: 15,
    dateOfBirth: undefined,
    state: undefined,
    isEditMode: false,
    productCover: [],
    medicalQuestions: []
  };
}
